import ReadOnlyService from '../base/ReadOnlyService';

class TemplateCategory extends ReadOnlyService {
  constructor() {
    super('template-categories');
  }
}

export default new TemplateCategory();
